export function parseRouteParamToString(
  value: string | null | undefined,
): string | null {
  if (typeof value === 'string') {
    return value;
  }

  return null;
}
